import { BasicModel } from '../../../../shared/domain/models/BasicModel';

export class SourceModel extends BasicModel {
  constructor({ id, name }: { id: string; name: string }) {
    super({ id, name });
  }
}
